import * as React from 'react';
import type { SVGProps } from 'react';
const SvgApplicationLog = (props: SVGProps<SVGSVGElement>) => {
  const uid = React.useId();
  const maskId = `${uid}-application-log-mask`;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={42}
      height={42}
      fill="none"
      viewBox="0 0 42 42"
      {...props}
    >
      <circle cx={21} cy={21} r={21} fill="#E6ECF4" />
      <mask
        id={maskId}
        width={24}
        height={24}
        x={9}
        y={9}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'alpha',
        }}
      >
        <path fill="#999" d="M9 9h24v24H9z" />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          fill="#3752B3"
          d="M14.4 29.4q-.743 0-1.271-.529A1.73 1.73 0 0 1 12.6 27.6V14.4q0-.743.529-1.271A1.73 1.73 0 0 1 14.4 12.6h4.275q.2-.775.838-1.287Q20.15 10.8 21 10.8t1.488.512q.638.513.837 1.288H27.6q.743 0 1.271.529.53.528.53 1.271v13.2q0 .743-.53 1.271a1.73 1.73 0 0 1-1.27.529zm0-1.8h13.2V14.4h-1.8v2.1a.87.87 0 0 1-.259.641.87.87 0 0 1-.64.259h-7.8a.87.87 0 0 1-.642-.259.87.87 0 0 1-.259-.641v-2.1h-1.8zm6.595-13.2a.88.88 0 0 0 .643-.257.86.86 0 0 0 .262-.638.88.88 0 0 0-.257-.643.86.86 0 0 0-.638-.262.88.88 0 0 0-.642.257.86.86 0 0 0-.263.638q0 .38.257.643a.86.86 0 0 0 .638.262"
        />
      </g>
    </svg>
  );
};
export default SvgApplicationLog;
